import { useAuthStore } from '@stores/auth';

export default defineNuxtPlugin(() => {
    const authStore = useAuthStore();
    const { errorLoggerSetUser } = useErrorLogger();

    if (authStore.isUserLoggedIn) {
        errorLoggerSetUser({ id: authStore.user?.id as string });
    }
});
